import {
	Box,
	Button,
	Card,
	Divider,
	Flex,
	Heading,
	SimpleGrid,
	Stack,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import { NAVIGATE } from 'constant/navigation';
import { useLocation, useNavigate } from 'react-router-dom';
import EducationLinks from 'views/client/education/components/EducationLinks';

export default function BitcoinBasics() {
	const textColor = useColorModeValue('gray.900', 'gray.100');
	const cardBg = useColorModeValue('gray.100', 'gray.500');
	const navigate = useNavigate();
	const location = useLocation();
	let isClient = false;
	if (location.pathname.includes('client')) isClient = true;

	return (
		<Box
			maxW={isClient ? '' : '900px'}
			alignSelf={isClient ? '' : 'center'}
			pt={isClient ? { base: '80px', md: '80px', xl: '80px' } : '0'}
		>
			<SimpleGrid
				mb='20px'
				columns={{ sm: 1, md: 1, lg: 1 }}
				spacing={{ base: '20px' }}
			>
				<Heading color={textColor} fontSize='2xl' ms='24px' fontWeight='700'>
					¿Qué es Bitcoin?
				</Heading>
				<Flex direction='column'>
					<Card bg={cardBg} mb={isClient ? '20px' : '50px'} p={6}>
						<Stack spacing={6}>
							<Heading size='md' color={textColor}>
								🌍 Libertad Financiera
							</Heading>
							<Text fontSize='md' color={textColor}>
								Bitcoin es una moneda digital descentralizada. A diferencia del
								dinero tradicional, no depende de bancos ni gobiernos, y se
								puede enviar a cualquier persona en el mundo en cuestión de
								segundos.
							</Text>

							<Text fontSize='md' color={textColor}>
								Lo interesante de Bitcoin es que no necesitas permiso para
								usarlo. Cualquiera puede tener una wallet y recibir pagos, sin
								importar si tiene cuenta de banco o no.
							</Text>

							<Divider />

							<Heading size='md' color={textColor}>
								🪙 ¿Por qué usamos Bitcoin en Bumbei?
							</Heading>

							<Text fontSize='md' color={textColor}>
								En lugar de gastar en publicidad tradicional, en Bumbei usamos
								ese presupuesto para recompensarte a ti en bitcoin cada vez que
								compras en línea.
							</Text>

							<Text fontSize='md' color={textColor}>
								Esto significa que con cada compra, estás dando tus primeros
								pasos en el mundo de Bitcoin, sin tener que invertir, sin
								complicaciones.
							</Text>

							<Divider />

							<Heading size='md' color={textColor}>
								🎯 ¿Qué puedo hacer con mis bitcoins?
							</Heading>

							<Text fontSize='md' color={textColor}>
								Puedes ahorrar, enviarle a otra persona, o incluso usarlo para
								pagar en comercios que aceptan Lightning. Lo importante es que
								ya tienes el control de tu dinero en una red global.
							</Text>

							{isClient && (
								<Box pt={4}>
									<Button
										as='a'
										onClick={() => navigate(NAVIGATE.EDUCATION_CENTER)}
										variant={'brand'}
									>
										Volver al centro educativo
									</Button>
								</Box>
							)}
						</Stack>
					</Card>
					<EducationLinks current={'basics'} isClient={isClient} />
				</Flex>
			</SimpleGrid>
		</Box>
	);
}
